import ConnectExchange from "features/portfolio/CreateAccount/ConnectExchange";
import SelectExchange from "features/portfolio/CreateAccount/SelectExchange";
import { AddClientResponse, ClientData } from "@shared/types";
import { getRouteWithExchange } from "utils/routes";
import { useHistory } from "react-router-dom";

interface CreateAccountContentProps {
  exchange?: string;
  account?: ClientData;
  onSubmitSuccess?: () => void;
  getErrorNotification?: (description: string, title?: string) => void;
  getSuccessMessage?: (
    response?: AddClientResponse,
    exchangesList?: string[]
  ) => void;
}

const CreateAccountContent = ({
  exchange,
  account,
  onSubmitSuccess,
  getErrorNotification,
  getSuccessMessage,
}: CreateAccountContentProps) => {
  const history = useHistory();

  if (exchange || account) {
    return (
      <ConnectExchange
        primaryExchange={exchange}
        onSubmitSuccess={onSubmitSuccess}
        getErrorNotification={getErrorNotification}
        account={account}
        getSuccessMessage={getSuccessMessage}
      />
    );
  }

  return (
    <SelectExchange
      onSelectExchange={(primaryExchange) =>
        history.push(getRouteWithExchange(primaryExchange))
      }
    />
  );
};

export default CreateAccountContent;
